import React from "react";
import amenities1 from '../img/amenities-1.jpeg'
import amenities2 from '../img/amenities-2.jpeg'
import amenities3 from '../img/amenities-3.jpeg'
import amenities4 from '../img/amenities-4.jpeg'
import amenities5 from '../img/amenities-5.jpeg'
import amenities6 from '../img/amenities-6.jpeg'
import amenities7 from '../img/amenities-7.jpg'


const amenites = [
  {
    icon: "fas fa-route", // Better icon for Jogging Track
    title: "Jogging Track",
    image: amenities1,
  },
  {
    icon: "fas fa-bolt", // Symbol for electric energy/charging
    title: "Electric Charging & Fire Alarm",
    image: amenities2,
  },
  {
    icon: "fas fa-building", // Represents the Emperia Icon building
    title: "Emperia Icon, Nerul",
    image: amenities3,
  },
  {
    icon: "fas fa-dumbbell", // Perfect for GYM
    title: "GYM – Emperia Icon",
    image: amenities7,
  },
  {
    icon: "fas fa-parking", // Dedicated icon for Parking
    title: "Parking",
    image: amenities3,
  },
  {
    icon: "fas fa-drafting-compass", // Suitable for Design & Build
    title: "Design Build",
    image: amenities6,
  },
];



const Amenities = () => {
  return (
    <div className="container-fluid service bg-light pb-5">
      <div className="container pb-5">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: "800px" }}>
          {/* <p className="text-uppercase text-secondary fs-5 mb-0">Our galleries</p> */}
          <h2 className="display-4 text-capitalize mb-3">
            Amenities
          </h2>
        </div>
        <div className="row g-4">
          {amenites.map((service, index) => (
            <div className="col-lg-4" key={index}>
              <div className="service-item">
                <div className="service-img">
                  <img
                    src={service.image}
                    className="img-fluid w-100"
                    alt={service.title}
                  />
                </div>
                <div className="service-content text-center p-4">
                  {/* <div
                    className="bg-secondary btn-xl-square mx-auto d-flex align-items-center justify-content-center"
                    style={{ width: "120px", height: "120px" }}
                  >
                  
                    <i className={`${service.icon} text-primary fa-4x`}></i>
                  </div> */}


{/* 
                  <a href="#" className="d-block fs-4 my-4">
                    {service.title}
                  </a>
                  <p className="text-white mb-4">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Mollitia, minima!
                  </p>
                  <a className="btn btn-secondary py-2 px-4" href="#">
                    Read More
                  </a> */}



                </div>
                <div className="service-tytle d-flex justify-content-between align-items-center ps-4 pe-4">


                  <h4>{service.title}</h4>
                  <div
                    className="btn-xl-square bg-secondary d-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className={`${service.icon} text-primary fa-2x`}></i>
                  </div>


                </div>
              </div>
            </div>
          ))}

          <div className="col-12 text-center">
            <a className="btn btn-secondary py-3 px-5 mt-4" href="#">
              More Amenities
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Amenities;
